/**
 * 文件说明: 客服考核统计
 * ----------------------------------------
 * 创建用户: 1625
 * 创建日期 2021/03/26
 */

import _ from 'lodash'
import {createProjectModel} from 'message-control/utils/project-model'
import {getList, postRule, deleteRule, getAssessWord, postAssessWord} from './service'

function formatParams(params) {
    const newParams = {}
    if (params.word) {
        newParams.word = params.word
    }
    if (params.date_range?.length) {
        newParams.start_time = `${params.date_range[0]} 00:00:00` || undefined
        newParams.end_time = `${params.date_range[1]} 23:59:59` || undefined
    }
    return newParams
}

const model = createProjectModel({
    projectNamespace: 'kpiConfig',
    state: {
        tableList: {}, // 带有机器人的群列表
        type: 2, // 1:敏感词，2：关键字
        assessWord: '', // 考核词
    },

    effects: {
        *getTableList(__, {select, put, call}) {
            const {tableList, type} = yield select((allState) => allState[model.namespace])
            const params = formatParams(tableList.params)
            const newParams = {
                offset: tableList.pagination.pageSize * (tableList.pagination.current - 1),
                limit: tableList.pagination.pageSize,
                ...params,
            }
            newParams.type = type
            const res = yield call(getList, {
                params: {
                    ...newParams,
                },
            })
            res.data.forEach((item, idx) => {
                if (!item.id) {
                    item.id = idx + 1
                }
            })
            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.tableList.dataSource = res.data
                    draft.tableList.pagination.total = _.get(res, 'pagination.rows_found', 0)
                },
            })
        },
        *getAssessWord(__, {put, call}) {
            const res = yield call(getAssessWord)
            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.assessWord = res.data
                },
            })
        },
        *postAssessWord({payload}, {put, call}) {
            const res = yield call(postAssessWord, payload)
            // 有返回词, 直接设置;
            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.assessWord = res.data
                },
            })
        },
        *postRule({payload}, {call}) {
            return yield call(postRule, payload)
        },

        *deleteRule({payload}, {call}) {
            return yield call(deleteRule, payload)
        },
    },
})
export default model
